/**
 * Stored parser_type values (must match backend ParserType enum).
 * UI shows a single "DocParser" option; both DocParser enum values are treated the same
 * (S3 ingress to CV2/source_docparser_cv2_init/).
 */
export const DOC_PARSER = 'DOC_PARSER';
export const DOC_PARSER_ALTERNATE_EXTRACTION = 'DOC_PARSER_ALTERNATE_EXTRACTION';
export const ALTERNATIVE_PARSER = 'ALTERNATIVE_PARSER';

/** DocParser family — uses extractor doc_parser + parser_id (fund drawer). */
export function isDocParserFamily(parserType) {
  return parserType === DOC_PARSER || parserType === DOC_PARSER_ALTERNATE_EXTRACTION;
}

export function isAlternativeParser(parserType) {
  return parserType === ALTERNATIVE_PARSER;
}

/** Normalize legacy DocParser variants to the single UI/storage value. */
export function normalizeParserType(parserType) {
  if (isDocParserFamily(parserType)) return DOC_PARSER;
  return parserType || DOC_PARSER;
}

/** Friendly label for grids and dropdowns. */
export function parserTypeLabel(parserType) {
  if (isDocParserFamily(parserType)) return 'DocParser';
  if (parserType === ALTERNATIVE_PARSER) return 'Alternative Parser';
  return parserType || 'N/A';
}
